import {CreateView} from '@src/components/_views/configurable/CreateView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import PaymentTypeForm from './PaymentTypeForm';

export class PaymentTypeCreateForm extends CreateView {
    protected getFormComponent() {
        return PaymentTypeForm;
    }
}

export default PaymentTypeCreateForm.getStoreConnector()(withRouterApi<FormViewProps>(PaymentTypeCreateForm));
